<template>
  <div class="p-6">
    <h2 class="text-xl font-semibold mb-4">Listado de Permisos</h2>
    <div class="dis-div">
      <v-row justify="start">
        <v-btn
          color="success"
          @click="showModal = true"
          class="ml-3 border-button"
          v-can="'Crear Permisos'"
        >
          Crear Permiso
          <v-icon class="ml-2">mdi mdi-plus-box-multiple-outline</v-icon>
        </v-btn>
      </v-row>
      <v-row justify="end">
        <!-- Buscador -->
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          hide-details
          label="Buscar permiso"
          single-line
          class="r-search"
        />
      </v-row>
    </div>
    <!-- Tabla -->
    <v-data-table
      :headers="headers"
      :items="permissions"
      :search="search"
      :loading="loading"
      loading-text="Cargando permisos..."
      class="elevation-1 mt-5"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          color="rgb(204 33 40)"
          class="white--text border-button"
          @click="editPermission(item)"
        >
          Editar
          <v-icon class="ml-2">mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-row justify="center">
      <!-- Modal mejorado -->
      <v-dialog v-model="showModal" max-width="1200px" persistent>
        <v-card>
          <v-card-title class="headline">
            {{ isEditing ? "Editar Permiso" : "Crear Permiso" }}
            <v-spacer></v-spacer>
            <v-btn icon @click="showModal = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="formValid">
              <v-text-field
                v-model="form.name"
                label="Nombre del Permiso"
                :rules="inputRules"
                :disabled="isEditing"
                required
              />
              <v-text-field
                v-model="form.description"
                label="Módulo / Descripción"
                :rules="inputRules"
                required
              />
            </v-form>
            <v-row justify="center">
              <v-col cols="12" sm="6">
                <v-alert
                  v-if="showAlert"
                  :type="alertType"
                  dense
                  outlined
                  border="left"
                  colored-border
                  class="my-4"
                >
                  {{ alertMessage }}
                </v-alert>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray" text @click="closeModal">Cancelar</v-btn>
            <v-btn
              style="background-color: rgb(204 33 40); color: white !important"
              @click="savePermission"
              :disabled="!formValid"
            >
              {{ isEditing ? "Guardar Cambios" : "Crear" }}
            </v-btn>
          </v-card-actions>
          <v-overlay :value="loading" absolute opacity="0.6">
            <v-progress-circular
              indeterminate
              size="64"
              color="rgb(204 33 40)"
            ></v-progress-circular>
          </v-overlay>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import { environment } from "@/data/environment";
export default {
  name: "PermissionsList",
  data() {
    return {
      search: "",
      headers: [
        { text: "ID", value: "id", align: "center" },
        { text: "Nombre del Permiso", value: "name", align: "center" },
        { text: "Módulo / Descripción", value: "description", align: "center" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      permissions: [],
      showModal: false,
      inputRules: [(v) => !!v || "Campo requerido"],
      formValid: false,
      form: {
        country: 1,
        name: "",
        description: "",
        id: "",
      },
      showAlert: false,
      alertMessage: "",
      alertType: "success",
      loading: false,
      isEditing: false,
    };
  },
  mounted() {
    this.fetchPermissions();
  },
  methods: {
    async fetchPermissions() {
      try {
        this.loading = true;
        const response = await axios.get(
          environment.HIOPOSWEBSERVICES + "/api/getPermissions/1"
        );

        this.permissions = response.data.data;
      } catch (error) {
        console.error("Error al obtener permisos:", error);
      } finally {
        this.loading = false;
      }
    },
    async savePermission() {
      try {
        this.loading = true;
        if (this.isEditing) {
          let editRole = {
            ...this.form,
          };
          console.log("Rol actualizado:", editRole);
          const response = await axios.post(
              `${environment.HIOPOSWEBSERVICES}/api/editPermission`,
              {
                permission: this.form,
                country: 1,
              }
            );
            if (response.data.error) {
              this.setAlert("error", response.data.message);
            } else {
              this.closeModal();
              this.fetchPermissions();
            }
        } else {
          if (!this.$refs.form.validate()) return;
  
          const index = this.permissions.findIndex(
            (p) => p.name === this.form.name
          );
          if (index === -1) {
            const response = await axios.post(
              `${environment.HIOPOSWEBSERVICES}/api/saveNewPermission`,
              {
                permission: this.form,
                country: 1,
              }
            );
            if (response.data.error) {
              this.setAlert("error", response.data.message);
            } else {
              this.closeModal();
              this.fetchPermissions();
            }
          } else {
            this.setAlert("warning", "El nombre del permiso ya existe!.");
          }
        }
      } catch (error) {
        console.error("Error guardando permiso:", error);
        this.setAlert("error", "Error al guardar el permiso.");
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      this.showModal = false;
      this.isEditing = false;
      this.form = { id: null, name: "", description: "" };
      this.$refs.form.resetValidation();
    },
    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },
    editPermission(permission) {
      this.isEditing = true;
      this.showModal = true;
      this.form = {
        country: 1,
        id: permission.id,
        name: permission.name,
        description: permission.description,
      };
      // Si tuvieras los permisos asociados:
      this.selectedPermissions = permission.permissions.map((p) => {
        return (
          this.availablePermissions.find((ap) => ap.name === p.name) || {
            name: p.name,
            description: p.description,
          }
        );
      });
    },
  },
};
</script>
<style scoped>
.r-search {
  max-width: 70%;
  margin-right: 1%;
}
.dis-div {
  display: flex !important;
}
.border-button {
  border-radius: 15px;
}
</style>
